//@ts-check
import React from 'react';
import Typography from '@material-ui/core/Typography';
import { isSpecified } from './util';

var MissingValue = function MissingValue() {
  return React.createElement(Typography, {
    color: "inherit",
    component: "span",
    display: "inline"
  }, "-");
};

MissingValue.isSpecified = isSpecified;
export default MissingValue;